import PropTypes from 'prop-types';

import OInput from '../../../UI/FormControls/OInput';
import TextArea from '../../../UI/FormControls/TextArea';
// import OAutocomplete from '../../../UI/MuiAutocomplete';

const Inputs = ({ formData, setFormData }) => {
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  // const handleAutocompleteChange = (event) => {
  //   const { id, vrednost } = event;
  //   setFormData((prevData) => ({
  //     ...prevData,
  //     idKupca: id,
  //     nazivKupca: vrednost,
  //   }));
  // };

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <div
        style={{
          display: 'flex',
          marginBottom: '20px',
          flexWrap: 'wrap',
          justifyContent: 'space-between',
        }}
      >
        {/* <OAutocomplete
        label="Naziv Kupca"
        data={korisniciData}
        value={formData.nazivKupca}
        style={{ width: '200px', cursor: 'pointer' }}
        handleClick={handleAutocompleteChange}
      /> */}
        <OInput
          label="Ime"
          name="ime"
          value={formData.ime}
          handleChange={handleInputChange}
          style={{ width: '300px', marginRight: '10px' }}
        />
        <OInput
          label="Prezime"
          name="prezime"
          value={formData.prezime}
          handleChange={handleInputChange}
          style={{ width: '300px', marginRight: '10px' }}
        />
        <OInput
          label="Kontakt telefon"
          name="kontaktTelefon"
          value={formData.kontaktTelefon}
          handleChange={handleInputChange}
          style={{ width: '300px', marginRight: '10px' }}
        />
        <OInput
          label="Email adresa"
          name="email"
          value={formData.email}
          handleChange={handleInputChange}
          style={{ width: '300px' }}
        />
      </div>
      <div>
        <TextArea
          label="Napomena"
          rows="4"
          name="napomena"
          value={formData.napomena}
          handleChange={handleInputChange}
          style={{ width: '100%', height: '60px' }}
        />
      </div>
    </div>
  );
};

Inputs.propTypes = {
  formData: PropTypes.object.isRequired,
  setFormData: PropTypes.func.isRequired,
};

export default Inputs;
